import { BZNAV_SIGN_IN_COMPLETE_EVENT_SENT_KEY, getCookieData } from '@repo/common-utils';
import { useUserEventLogger } from '@repo/tracking-service';
import { useAuthContext } from '@repo/user-session';
import { useEffect, useRef } from 'react';

import { BZNAV_LAST_SIGN_IN_COOKIE_KEY } from '../constants';

export const useIntegrateAuthEventTracking = () => {
  const { auth, authService } = useAuthContext();
  const currentUser = useRef<string>(undefined);
  const { mixpanelDeviceId, setUser, unsetUser, sendCustomActionEvent, sendMetaEvent, sendKakaoEvent, sendNaverEvent } = useUserEventLogger();

  useEffect(() => {
    authService?.initializeSession(mixpanelDeviceId);
  }, [authService, mixpanelDeviceId]);

  useEffect(() => {
    if (auth.user && Object.keys(auth.user).length > 0) {
      const jsonUserData = JSON.stringify(auth.user);
      if (jsonUserData !== currentUser.current) {
        currentUser.current = jsonUserData;
        setUser(auth.user);
      }
    } else {
      currentUser.current = undefined;
      unsetUser();
    }
  }, [auth.user, setUser, unsetUser]);

  useEffect(() => {
    const lastSignInItem = getCookieData(BZNAV_LAST_SIGN_IN_COOKIE_KEY);
    const isEventSent = localStorage.getItem(BZNAV_SIGN_IN_COMPLETE_EVENT_SENT_KEY);
    if (!isEventSent && auth.status === 'login') {
      let eventProperty = {
        type: lastSignInItem
      };

      // 환급 랜딩 A/B 테스트가 진행 중인 경우 실험정보를 Property에 포함
      const savedTestData = localStorage.getItem('zent_landing_test_data');
      if (savedTestData) {
        const data = JSON.parse(savedTestData);
        eventProperty = {
          ...data,
          ...eventProperty
        };
      }
      sendCustomActionEvent('sign-in', 'complete', eventProperty);
      sendMetaEvent('Lead');
      sendKakaoEvent('login');
      sendNaverEvent({ type: 'sign_up' });
      localStorage.setItem(BZNAV_SIGN_IN_COMPLETE_EVENT_SENT_KEY, 'true');
    } else if (isEventSent && auth.status === 'logout') {
      localStorage.removeItem(BZNAV_SIGN_IN_COMPLETE_EVENT_SENT_KEY);
    }
  }, [auth.status, sendCustomActionEvent, sendKakaoEvent, sendMetaEvent, sendNaverEvent]);
};
